import { Component as ReactComponent } from 'react';
const ignoredMethods = [
  'render',
  'getDefaultProps',
  'getInitialState',
  'getChildContext',
  'componentWillMount',
  'componentDidMount',
  'componentWillReceiveProps',
  'shouldComponentUpdate',
  'componentWillUpdate',
  'componentDidUpdate',
  'componentWillUnmount',
  'updateComponent'
];

export default class Component extends ReactComponent {
  static reducer = null;

  constructor(props) {
    super(props);

    const proto = this.constructor.prototype;
    const keys = Object.getOwnPropertyNames(proto);

    keys
      .filter((key) => {
        return ignoredMethods.indexOf(key) === -1 && isFunction(proto[key]);
      })
      .forEach((key) => {
        this[key] = proto[key].bind(this);
      });
  }
}

function isFunction(o) {
  return Boolean(o && o.constructor && o.call && o.apply);
}


// WEBPACK FOOTER //
// ./src/components/component.jsx